/**
 * How an adoption plan names a form on screen.
 *
 * The NAME leads: it is what a person recognises, and it is unique within a
 * study. The CODE follows in brackets when the form has one. A form without a
 * stored code — three forms in four on the large environments — used to show
 * as nothing at all in the "on form" column, so two uncoded forms could not
 * be told apart (Jim, 2026-09-14).
 *
 * A plan from a function deployed before rows carried the form name has only
 * the code; that still shows, alone, rather than blank.
 */
export function adoptFormLabel(form: { name?: string; code?: string }): string {
  const name = (form.name ?? '').trim();
  const code = (form.code ?? '').trim();
  if (name && code) return `${name} (${code})`;
  if (name) return name;
  if (code) return code;
  return '(unnamed form)';
}
